import styled, { css } from 'styled-components';

import LockedIcon from 'components/icons/locked';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';
import { RewardsCarousel } from 'components/rewards-carousel';
import { LoyaltyLoader } from 'pages/loyalty/loyalty-loader';
import { primitive } from 'styles/constants/primitives';
import { delayUnmountHOC } from 'utils/delay-unmount-hoc';

export const CATEGORY_TRANSITION_TIME = 350;

const RewardContainer = styled.div``;
const CATEGORY_HEADER_HEIGHT = '2.75rem';
const CATEGORY_HEADER_WIDTH = '23.4375rem;';

export const DelayedUnmountRewardContainer = delayUnmountHOC(RewardContainer);

export const RewardCategoryAccordion = styled.li<{
  open: boolean;
  categoryHeight: number;
  isCurrentSelection: boolean;
}>`
  height: ${p => `calc(${p.open ? p.categoryHeight : 0}rem + ${CATEGORY_HEADER_HEIGHT})`};
  width: ${CATEGORY_HEADER_WIDTH};
  display: flex;
  width: 100%;
  transition: height ${CATEGORY_TRANSITION_TIME / 1000}s;
  overflow: hidden;
  flex-direction: column;
  background: ${Styles.color.white};

  ${p =>
    p.isCurrentSelection &&
    css`
      position: relative;
      z-index: ${Styles.zIndex.top};
    `}
`;

export const CategoryHeader = styled.h4`
  flex-shrink: 0;
  width: 100%;
  height: ${CATEGORY_HEADER_HEIGHT};
  padding: 0;
  margin: 0;
  border-bottom: 1px solid ${Styles.color.grey.four};
`;

export const AccordionTrigger = styled.button`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0 1rem;
  background-color: ${Styles.color.white};
  border: none;
  cursor: pointer;

  &[aria-expanded='true'] svg {
    transition: 0.35s;
    transform: rotate(180deg);
  }
`;

export const CategoryImage = styled(Picture)`
  height: 1.7rem;
  width: 1.7rem;
  margin-right: 0.75rem;
`;

export const CategoryLabel = styled.span`
  flex: 1;
  text-align: left;
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.25rem;
  font-weight: ${Styles.fontWeight.normal};
`;

export const LoyaltyRewardsTitle = styled.h3`
  background: ${primitive.$white};
  margin: 0;
  padding: 1rem;
  font-family: ${Styles.fontFamily.brand};
`;

export const StyledLoyaltyLoader = styled(LoyaltyLoader)`
  height: 80vh;
`;

export const EmptyStateContainer = styled.div`
  padding: 5em 3em;
`;

export const CarouselSection = styled.div`
  width: 100%;
`;

export const CarouselHeadingContainer = styled.div`
  background: rgba(0, 0, 0, 0.04);
  padding: 1em 0;
  margin-bottom: 0.6em;

  ${Styles.desktop`
    margin-bottom: 0;
  `}
`;

export const CarouselHeading = styled.div`
  display: flex;
  max-width: 87.5rem;
  margin: 0 auto;
  font-family: 'Flame';
  font-style: normal;
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2.125rem;
`;

export const HeadingLoyaltyIcon = styled(LoyaltyPointsIcon)`
  width: 2rem;
  margin-left: 0.5em;
  margin-right: 0.4em;

  ${Styles.desktop`
    margin-left: 0;
    margin-right: 0.7em;
  `}
`;

export const ItemLoyaltyIcon = styled(LoyaltyPointsIcon)`
  width: 1.5rem;
  margin-right: 0.5rem;

  path {
    fill: ${Styles.color.alert.info.background};
  }
`;

export const HeadingLockedIcon = styled(LockedIcon)`
  position: initial;
  width: 2rem;
  height: 1.2rem;
  margin-top: 0.425rem;
  margin-right: 0.2em;
  margin-left: 0.5em;

  ${Styles.desktop`
    margin-left: 0;
    margin-right: 0.7em;
  `}
`;

export const CarouselHeadingLabel = styled.span`
  font-weight: 600;
`;

export const PointsNeededText = styled.div`
  font-size: 1.3rem;
  margin-left: auto;
  margin-right: 0.5em;

  ${Styles.desktop`
    margin-right: 0;
  `}
`;

export const CarouselSectionRewards = styled.div`
  display: flex;
  justify-content: center;
  max-width: 106.25rem;
  margin: 2rem auto;
  list-style: none;
`;

export const CarouselItem = styled.div`
  position: relative;
  background: white;
  width: 9.375rem;
  height: 15.5rem;
  border-radius: 0.75rem;
  margin: 1rem 0 0 0;
  padding: 0 0.3rem 0.3rem 0.3rem;
  cursor: pointer;

  ${Styles.desktop`
    width: 18.75rem;
    height: 21.875rem;
    margin: 0 1rem;
  `}
`;

export const CarouselRewardLock = styled(LockedIcon)`
  margin: 0.313rem 0.625rem 0.313rem 0.313rem;
`;

export const CardWrapper = styled.div<{ locked?: boolean }>`
  pointer-events: ${p => (p.locked ? 'none' : 'auto')};
`;

export const PictureWrapper = styled.div`
  width: 100%;
  height: 8rem;

  ${Styles.desktop`
    height: 14rem;
  `}
`;

export const HiddenCarouselItem = styled(CarouselItem)`
  visibility: hidden;
`;

export const CarouselRewardName = styled.div`
  font-family: 'Flame';
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  text-align: center;
  height: 3rem;
  line-height: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ${Styles.desktop`
  font-size: 1.2rem;
  `}
`;

export const CarouselItemPoints = styled.div<{ locked?: boolean }>`
  display: flex;
  background: ${p =>
    p.locked ? Styles.color.codeBlockBackground : Styles.color.contrastBackground};
  color: ${p => (p.locked ? Styles.color.contrastBackground : primitive.$white)};
  width: fit-content;
  margin: 0.5em auto 0;
  padding: 0.2em 0.6em;
  border-radius: 0.25rem;
  font-weight: 700;
`;

export const StyledRewardsCarousel = styled(RewardsCarousel)``;
